import React, { FC } from 'react'
import { LocaleSwitcher } from '../../common/intl/LocaleSwitcher'
import { FooterMenu } from './FooterMenu'
import { HeaderLogo } from '../header/HeaderLogo'
import { Locale } from '../../common/intl/Locale'

export const Footer: FC<{ locales?: Locale[] }> = ({ locales }) => {
  return (
    <footer className="border-t border-gray-100 bg-blue-900 text-white/50">
      <div className="container flex flex-col items-center gap-6 py-8 md:flex-row md:py-4">
        <HeaderLogo className="text-white" />

        <FooterMenu />

        <LocaleSwitcher className="md:ml-auto" locales={locales} />
      </div>
    </footer>
  )
}
